import React from 'react'
import Trash from '../icons/Trash'
import { useState } from 'react'
import Modal from './Modal'
import RemoveSlideModal from './RemoveSlideModal'

const RemoveSlideButton = () => {
  const [isOpen, setIsOpen] = useState(false)
  return (
    <>
      <div
        className="bg-slateGray px-4 py-2 rounded-md flex items-center gap-1 cursor-pointer"
        onClick={() => setIsOpen(true)}>
        <div className="text-white w-5 h-5">
          <Trash />
        </div>
        <div className="text-14 font-semibold text-white">Remove Slide</div>
      </div>
      <Modal isOpen={isOpen} toggleModal={() => setIsOpen(!isOpen)}>
        <RemoveSlideModal onClose={() => setIsOpen(false)} />
      </Modal>
    </>
  )
}

export default RemoveSlideButton
